document.addEventListener("DOMContentLoaded", () => {
    //publish(PUB_SUB_EVENTS.ffProgresBarUpdate, { 'questionIndex': 1, 'isQuestionNext': true });
    setCookieUtm();
    wishlistNotifyMeRedirect();
    storageRuleContexts();
});

const setCookieUtm = () => {
    const utm_source = UrlUtils.getQueryParam('promo');
    if (utm_source && CookieUtils.setCookie) {
        CookieUtils.setCookie('promo', utm_source, 30);
    }
}

const wishlistNotifyMeRedirect = () => {
    let redirectFromWishlist = false;
    setTimeout(() => {
        let notifyButtons = document.querySelectorAll('.custom-restock-button');
        if(window.location.pathname.includes('pages/wishlist')){
        notifyButtons.forEach(button => {
            button.addEventListener('click', (e) => {
            e.preventDefault();
            let productId = button.id.replace('restock-','');
            sessionStorage.setItem(redirectFromWishlist, 'true');
            window.location.href = window.location.origin + '/products/' +  productId;
            });
        });
        }
    }, 2000);

    setTimeout(() => {
    if(window.location.pathname.includes('products') && document.referrer.includes('pages/wishlist') && sessionStorage.getItem(redirectFromWishlist) === 'true') {
        let button = document.querySelector('.custom-restock-button')
        if (!button) return;
        if (sessionStorage.getItem(redirectFromWishlist) === 'true'){
            button.click();
            sessionStorage.setItem(redirectFromWishlist, 'false');
        }
        }
    }, 300)
}

const storageRuleContexts = () => {
    //get ruleContexts from url params using UrlUtils.getQueryParam
    const ruleContexts = UrlUtils.getQueryParam('ruleContexts');
    if (ruleContexts) {
        sessionStorage.setItem('ruleContexts', JSON.stringify(ruleContexts));
    }
    else {
        sessionStorage.removeItem('ruleContexts');
    }
}